// Button component translations
export default {
  // Basic action buttons
  save: "Save",
  cancel: "Cancel",
  confirm: "Confirm",
  delete: "Delete",
  edit: "Edit",
  create: "Create",
  add: "Add",
  remove: "Remove",
  update: "Update",
  submit: "Submit",
  reset: "Reset",
  clear: "Clear",
  search: "Search",
  filter: "Filter",
  export: "Export",
  import: "Import",
  download: "Download",
  upload: "Upload",
  copy: "Copy",
  paste: "Paste",
  close: "Close",

  // Status buttons
  loading: "Loading...",
  saving: "Saving...",
  deleting: "Deleting...",
  uploading: "Uploading...",
  downloading: "Downloading...",
  processing: "Processing...",

  // Navigation buttons
  back: "Back",
  next: "Next",
  previous: "Previous",
  finish: "Finish",
  continue: "Continue",

  // Pagination buttons
  firstPage: "First",
  lastPage: "Last",
  prevPage: "Previous",
  nextPage: "Next",

  // Confirmation buttons
  yes: "Yes",
  no: "No",
  ok: "OK",
  apply: "Apply",
  retry: "Retry",
  refresh: "Refresh",
  reload: "Reload",
};
